import BaseEntity from '../BaseEntity.model';

import { StatusEnum } from '../../Enum/StatusEnum';
import { CreatedBy } from '../Shared/CreatedBy.model';
export default interface IHamiltonAnxietyScaleModel extends BaseEntity {
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    Anxious: number;
    Tension: number;
    Fears: number;
    Insomnia: number;
    Intellectual: number;
    DepressedMood: number;
    SomaticMuscular: number;
    SomaticSensory: number;
    Cardiovascular: number;
    Respiratory: number;
    Gastrointestinal: number;
    Genitourinary: number;
    AutonomicSymptoms: number;
    BehaviorAtInterview: number;
    IsAIAnxious: boolean;
    IsAITension: boolean;
    IsAIFears: boolean;
    IsAIInsomnia: boolean;
    IsAIIntellectual: boolean;
    IsAIDepressedMood: boolean;
    IsAISomaticMuscular: boolean;
    IsAISomaticSensory: boolean;
    IsAICardiovascular: boolean;
    IsAIRespiratory: boolean;
    IsAIGastrointestinal: boolean;
    IsAIGenitourinary: boolean;
    IsAIAutonomicSymptoms: boolean;
    IsAIBehaviorAtInterview: boolean;
    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
}

export class HamiltonAnxietyScaleModel implements IHamiltonAnxietyScaleModel {
    Id: string;
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    Anxious: number;
    Tension: number;
    Fears: number;
    Insomnia: number;
    Intellectual: number;
    DepressedMood: number;
    SomaticMuscular: number;
    SomaticSensory: number;
    Cardiovascular: number;
    Respiratory: number;
    Gastrointestinal: number;
    Genitourinary: number;
    AutonomicSymptoms: number;
    BehaviorAtInterview: number;
    IsAIAnxious: boolean;
    IsAITension: boolean;
    IsAIFears: boolean;
    IsAIInsomnia: boolean;
    IsAIIntellectual: boolean;
    IsAIDepressedMood: boolean;
    IsAISomaticMuscular: boolean;
    IsAISomaticSensory: boolean;
    IsAICardiovascular: boolean;
    IsAIRespiratory: boolean;
    IsAIGastrointestinal: boolean;
    IsAIGenitourinary: boolean;
    IsAIAutonomicSymptoms: boolean;
    IsAIBehaviorAtInterview: boolean;
    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
        this.IsAIAnxious = false;
        this.IsAITension = false;
        this.IsAIFears = false;
        this.IsAIInsomnia = false;
        this.IsAIIntellectual = false;
        this.IsAIDepressedMood = false;
        this.IsAISomaticMuscular = false;
        this.IsAISomaticSensory = false;
        this.IsAICardiovascular = false;
        this.IsAIRespiratory = false;
        this.IsAIGastrointestinal = false;
        this.IsAIGenitourinary = false;
        this.IsAIAutonomicSymptoms = false;
        this.IsAIBehaviorAtInterview = false;
        this.IsAssessmentCompleted = false;
        this.AssessmentStatus = 0;
    }
}
